// extracted by mini-css-extract-plugin
export default {"footer":"MobileFooter_footer__iOeTj","unreadNotifications":"MobileFooter_unreadNotifications__zYaNg"};